import React, { useEffect } from 'react';
import cn from 'classnames';

// REDUX
import { useAppSelector } from '@Managers/Redux/Hooks';
import { getAuthenticateGameConfig, getDeviceInfo, getGlobalStyles } from '@Managers/Redux/AppState/AppState';

// CSS
import styles from '@UILayer/UILayer.scss';

// IMAGES

//BUTTONS
import { FullscreenButton, DebugPanelButton, BonusBuyButton } from '@UILayer/Buttons';
import ConfigLoader from '@ConfigLoader/ConfigLoader';
import { EConfigurationNames } from '@ConfigLoader/ConfigFiles';

const CornerPanel: React.FC<{}> = ({}) => {
    const globalStyles = useAppSelector(getGlobalStyles);
    const device = useAppSelector(getDeviceInfo);
    const gameStoreAuthenticateGameConfig = useAppSelector(getAuthenticateGameConfig);

    const classes = cn(styles.cornerPanel_container, globalStyles.orientation, globalStyles.handMode);

    useEffect(() => {}, []);

    return (
        <>
            <div className={classes}>
                <div className={styles.cornerPanel_menu}>
                    <FullscreenButton />
                    <DebugPanelButton />
                    {device.windowOrientationPortrait && gameStoreAuthenticateGameConfig.bonusBuy && <BonusBuyButton />}
                </div>
            </div>
        </>
    );
};

export default CornerPanel;
